import React from 'react';
import { useTranslation } from 'react-i18next';

const IconDashboard = () => (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="7" height="9" rx="1" /><rect x="14" y="3" width="7" height="5" rx="1" />
        <rect x="14" y="12" width="7" height="9" rx="1" /><rect x="3" y="16" width="7" height="5" rx="1" />
    </svg>
);

const IconAnalytics = () => (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
    </svg>
);

const IconAudit = () => (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 2h10l6 6v14H4z" /><path d="M14 2v6h6" /><path d="M9 13h6" /><path d="M9 17h6" />
    </svg>
);

const IconHelp = () => (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" /><path d="M9.1 9a3 3 0 1 1 5.82 1c-.35.86-1.3 1.3-1.92 1.98-.5.55-.5 1.02-.5 1.52" /><path d="M12 17h.01" />
    </svg>
);

const IconSettings = () => (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.66 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9c.32-.62.26-1.36-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06c.46.59 1.2.65 1.82.33.62-.32 1.02-.9 1-1.51V3a2 2 0 1 1 4 0v.09c0 .61.38 1.19 1 1.51.62.32 1.36.26 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06c-.59.46-.65 1.2-.33 1.82z" />
    </svg>
);

const IconLanguage = () => (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" /><path d="M2 12h20" />
        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    </svg>
);

const IconReports = () => (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" /><polyline points="10 9 9 9 8 9" />
    </svg>
);

const IconCollapse = () => (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="4" width="18" height="16" rx="2" /><path d="M9 4v16" /><path d="m5 10 2 2-2 2" />
    </svg>
);

const IconSignOut = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><path d="M16 17l5-5-5-5" /><path d="M21 12H9" />
    </svg>
);

const SETTINGS_ITEM_DEFS = [
    { id: 'thresholds', label: 'Thresholds', adminOnly: false },
    { id: 'webhook',    label: 'Webhooks',   adminOnly: true  },
];

// Analytics submenu items — labels resolved via t() at render time
const ANALYTICS_ITEM_DEFS = [
    { id: 'overview',      tKey: 'nav.overview',      adminOnly: true,   managerOnly: false },
    { id: 'my-usage',      tKey: 'nav.myUsage',       adminOnly: false,  managerOnly: false },
    { id: 'my-team',       tKey: 'nav.myTeam',        adminOnly: false,  managerOnly: true  },
    { id: 'activity',      tKey: 'nav.recentActivity', adminOnly: true,  managerOnly: false },
    { id: 'users',         tKey: 'nav.users',         adminOnly: true,   managerOnly: false },
    { id: 'teams',         tKey: 'nav.teams',         adminOnly: true,   managerOnly: false },
    { id: 'keys',          tKey: 'nav.keys',          adminOnly: true,   managerOnly: false },
    { id: 'departments',   tKey: 'nav.departments',   adminOnly: true,   managerOnly: false },
    { id: 'organisations', tKey: 'nav.organisations', adminOnly: true,   managerOnly: false },
    { id: 'models',        tKey: 'nav.models',        adminOnly: true,   managerOnly: false },
    { id: 'admins',        tKey: 'nav.admins',        adminOnly: true,   managerOnly: false },
];

const Sidebar = ({
    isOpen,
    onClose,
    view,
    onDashboard,
    onAnalytics,
    onReports,
    onAuditLog,
    onHelp,
    onSettings,
    onLogout,
    userEmail,
    userName,
    userPhoto,
    userOrgUnit,
    userDepartment,
    isAdmin,
    isManager,
    myDirectReports = [],
    language,
    onToggleLanguage,
    analyticsSubTab,
    onAnalyticsSubTab,
    settingsSubTab,
    onSettingsSubTab,
}) => {
    const { t } = useTranslation();
    const [analyticsExpanded, setAnalyticsExpanded] = React.useState(view === 'analytics');
    const [settingsExpanded, setSettingsExpanded] = React.useState(view === 'settings');

    // Keep expanded when navigating into analytics or settings
    React.useEffect(() => {
        if (view === 'analytics') setAnalyticsExpanded(true);
        if (view === 'settings') setSettingsExpanded(true);
    }, [view]);


    const initials = (userName || userEmail || 'U')
        .split(/[\s@.]+/)
        .filter(Boolean)
        .slice(0, 2)
        .map(s => s[0].toUpperCase())
        .join('');

    const roleLabel = isAdmin ? t('nav.admin') : isManager ? t('nav.manager') : t('nav.staff');

    const visibleItems = ANALYTICS_ITEM_DEFS
        .filter(item => {
            if (item.adminOnly && !isAdmin) return false;
            if (item.managerOnly && (!isManager || myDirectReports.length === 0) && !isAdmin) return false;
            return true;
        })
        .map(item => ({ ...item, label: t(item.tKey) }));

    const visibleSettingsItems = SETTINGS_ITEM_DEFS
        .filter(item => !item.adminOnly || isAdmin);

    return (
        <>
            {isOpen && (
                <div className="sidebar-backdrop" onClick={onClose} />
            )}
            <div className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
                <div className="sidebar-header">
                    <div className="sidebar-logo">
                        <img src="/AwareAI-logo.png" alt="AwareAI" />
                    </div>
                    <button className="sidebar-collapse-btn" onClick={onClose} aria-label="Collapse menu">
                        <IconCollapse />
                    </button>
                </div>

                <div className="sidebar-nav-scroll">
                <span className="sidebar-section-label">{t('nav.platform')}</span>

                <button
                    className={`sidebar-nav-btn ${view === 'dashboard' ? 'active' : ''}`}
                    onClick={() => { onDashboard(); onClose(); }}
                >
                    <IconDashboard />
                    {t('nav.dashboard')}
                </button>

                {/* Analytics toggle — clickable, expands/collapses submenu */}
                <button
                    className={`sidebar-nav-btn ${view === 'analytics' ? 'active' : ''}`}
                    onClick={() => setAnalyticsExpanded(e => !e)}
                    style={{ justifyContent: 'space-between' }}
                >
                    <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <IconAnalytics />
                        {t('nav.analytics')}
                    </span>
                    <svg
                        width="13" height="13" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                        style={{ transition: 'transform 0.2s', transform: analyticsExpanded ? 'rotate(90deg)' : 'rotate(0deg)', flexShrink: 0 }}
                    >
                        <path d="m9 18 6-6-6-6" />
                    </svg>
                </button>

                {/* Analytics sub-items — shown when expanded */}
                {analyticsExpanded && (
                    <div style={{ paddingLeft: 12, marginBottom: 4 }}>
                        {visibleItems.map(item => (
                            <button
                                key={item.id}
                                className="sidebar-nav-btn"
                                style={{
                                    fontSize: '0.82rem',
                                    paddingLeft: 22,
                                    paddingTop: 7,
                                    paddingBottom: 7,
                                    color: view === 'analytics' && analyticsSubTab === item.id ? 'var(--fg-primary)' : 'var(--fg-secondary)',
                                    background: view === 'analytics' && analyticsSubTab === item.id ? 'var(--border)' : 'none',
                                    borderLeft: view === 'analytics' && analyticsSubTab === item.id ? '2px solid var(--accent)' : '2px solid transparent',
                                    borderRadius: '0 6px 6px 0',
                                    marginBottom: 1,
                                }}
                                onClick={() => {
                                    onAnalyticsSubTab(item.id);
                                    onClose();
                                }}
                            >
                                {item.label}
                            </button>
                        ))}
                    </div>
                )}

                <button
                    className={`sidebar-nav-btn ${view === 'reports' ? 'active' : ''}`}
                    onClick={() => { onReports(); onClose(); }}
                >
                    <IconReports />
                    {t('nav.reports')}
                </button>

                <button
                    className="sidebar-nav-btn"
                    onClick={() => { onAuditLog(); onClose(); }}
                >
                    <IconAudit />
                    {t('nav.auditLog')}
                </button>

                <span className="sidebar-section-label mt">{t('nav.support')}</span>

                <button className="sidebar-nav-btn" onClick={() => { onHelp(); onClose(); }}>
                    <IconHelp />
                    {t('nav.helpSupport')}
                </button>

                {/* Settings toggle — expandable submenu */}
                <button
                    className={`sidebar-nav-btn ${view === 'settings' ? 'active' : ''}`}
                    onClick={() => setSettingsExpanded(e => !e)}
                    style={{ justifyContent: 'space-between' }}
                >
                    <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <IconSettings />
                        {t('app.settings')}
                    </span>
                    <svg
                        width="13" height="13" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                        style={{ transition: 'transform 0.2s', transform: settingsExpanded ? 'rotate(90deg)' : 'rotate(0deg)', flexShrink: 0 }}
                    >
                        <path d="m9 18 6-6-6-6" />
                    </svg>
                </button>

                {settingsExpanded && (
                    <div style={{ paddingLeft: 12, marginBottom: 4 }}>
                        {visibleSettingsItems.map(item => (
                            <button
                                key={item.id}
                                className="sidebar-nav-btn"
                                style={{
                                    fontSize: '0.82rem',
                                    paddingLeft: 22,
                                    paddingTop: 7,
                                    paddingBottom: 7,
                                    color: view === 'settings' && settingsSubTab === item.id ? 'var(--fg-primary)' : 'var(--fg-secondary)',
                                    background: view === 'settings' && settingsSubTab === item.id ? 'var(--border)' : 'none',
                                    borderLeft: view === 'settings' && settingsSubTab === item.id ? '2px solid var(--accent)' : '2px solid transparent',
                                    borderRadius: '0 6px 6px 0',
                                    marginBottom: 1,
                                }}
                                onClick={() => {
                                    onSettingsSubTab(item.id);
                                    onClose();
                                }}
                            >
                                {item.label}
                            </button>
                        ))}
                    </div>
                )}

                <button className="sidebar-nav-btn" onClick={onToggleLanguage}>
                    <IconLanguage />
                    {t('settings.language')}: {language === 'th' ? 'TH' : 'EN'}
                </button>
                </div>{/* end sidebar-nav-scroll */}

                <div className="sidebar-footer">
                    <div className="sidebar-user">
                        {userPhoto
                            ? <img src={userPhoto} alt={initials} className="sidebar-avatar sidebar-avatar--photo" />
                            : <div className="sidebar-avatar">{initials}</div>
                        }
                        <div className="sidebar-user-info">
                            <div className="sidebar-user-name" title={userEmail}>
                                {userName || userEmail}
                            </div>
                            <div className="sidebar-user-role">{roleLabel}</div>
                            {(userOrgUnit || userDepartment) && (
                                <div className="sidebar-user-org" title={[userOrgUnit, userDepartment].filter(Boolean).join(' / ')}>
                                    {[userOrgUnit, userDepartment].filter(Boolean).join(' / ')}
                                </div>
                            )}
                        </div>
                    </div>
                    <button className="sidebar-signout-btn" onClick={onLogout}>
                        <IconSignOut />
                        {t('nav.signOut')}
                    </button>
                </div>
            </div>
        </>
    );
};

export default Sidebar;

